///<reference path='../../typings/index.d.ts' />

module agi.expressions.card.animation {

    import MovieClip = PIXI.extras.MovieClip;
    import Container = PIXI.Container;
    import Event = agi.expressions.event.Event;
    import EventBus = agi.expressions.event.EventBus;

    export type ItemAnimationTextureData = {framePrefixId:string;nFrames:number};
    export type ItemAnimationStatesTexturData = {rest:ItemAnimationTextureData,leave:ItemAnimationTextureData,shadow:ItemAnimationTextureData,glow:ItemAnimationTextureData};
    export type TweenToData = {duration:number;vars:any};

    export class AnimatedItem {
        public restAnimationDelay:number;
        public container:Container;
        public idleModifier:number = 1;
        public idleDelay:number = Math.ceil(Math.random()*1000);
        public leaveTween:TimelineMax;
        public leaveTweenStarted:Signal = new signals.Signal();

        private tweenContainer:Container; // non-scaled container (normalized)
        private tweenState:any = {x:0, y:0, rotation:0, scaleX:1, scaleY:1};
        private leaveTweenScale:{x:number,y:number} = {x:1,y:1};
        private leaveMC:MovieClip;
        private restMC:MovieClip;
        public glowMC:MovieClip;
        private restRepeat:number = 1;
        private restRepeatCount:number = 0;
        private isIdling:boolean = false;
        private isLeaving:boolean = false;
        private lastX =-99;
        private lastY =-99;
        private eventBus = EventBus.getInstance();
        
        constructor(private animationsTextureData:ItemAnimationStatesTexturData,
                    private leaveTweenData?:TweenToData[]){            
            this.init();
        }

        public init():void{
            // container
            this.container = new Container();
            this.tweenContainer = new Container();

            this.leaveMC = this.createMovieClip(this.animationsTextureData.leave);
            this.restMC = this.createMovieClip(this.animationsTextureData.rest);
            this.glowMC = this.createMovieClip(this.animationsTextureData.glow);

            this.leaveMC.visible = false;    
            this.glowMC.visible=false;            

            this.container.addChild(this.tweenContainer);
            this.tweenContainer.addChild(this.glowMC);
            this.tweenContainer.addChild(this.leaveMC);
            this.tweenContainer.addChild(this.restMC);

            if(this.leaveTweenData !== undefined){
                this.setLeaveTween(this.leaveTweenData);
            }
        }

        public setAlpha(alpha:number):void{
            this.container.alpha = alpha; 
        }

        public setPosition(x:number, y:number) {
            this.container.x = x;
            this.container.y = y;
        }

        public setScale(sc:number) {
            this.container.scale.x =
                this.container.scale.y = sc;
        }

        public setRotation(rot:number){
            this.container.rotation = rot;
        }

        public doRestAnimation(repeat:number=1):void{
            if(!this.isIdling){
                this.isIdling=true;
                if(repeat>=2){
                    this.restMC.animationSpeed = 1;
                    this.glowMC.animationSpeed = 1;
                }else{
                    this.restMC.animationSpeed = 0.4;
                    this.glowMC.animationSpeed = 0.4;
                }
                this.restRepeat = repeat;
                this.restRepeatCount = 0;
                this.restMC.gotoAndPlay(1);
                this.glowMC.gotoAndPlay(1);
            }
        }

        public resetLeaveAnimation():void{
            this.leaveMC.gotoAndStop(0);
            this.glowMC.gotoAndStop(0);
            this.leaveTween.reverse();
            this.isLeaving=false;
            var animatedItemResetEvent:Event = new Event("animatedItemResetStart", this);
            this.eventBus.dispatchEvent(animatedItemResetEvent);
        }

        public doLeaveAnimation():void{
            this.restMC.visible = false;
            this.leaveMC.visible = true;
            this.glowMC.visible=false;
            this.leaveMC.play();                        
            if(typeof this.leaveTween !== 'undefined' && !this.isLeaving)
            {
                this.leaveTween.play();
                this.leaveTweenStarted.dispatch();
            }
            this.isLeaving=true;
        }

        public animate(deltaTime?:number):void{
            if(this.restMC.visible){
                //random flap when idle
                if(this.idleDelay<=0 && !this.isIdling){
                    this.idleDelay=this.idleModifier*1000+(Math.round(Math.random()*200));
                    this.doRestAnimation(1);
                    this.isIdling=true;
                }else{
                    this.idleDelay--;
                }               
                if(this.restMC.playing){
                    if(this.restMC.currentFrame == (this.restMC.totalFrames-1)){
                        this.restRepeatCount++;
                        if(this.restRepeatCount == this.restRepeat){
                            this.restMC.stop();
                            this.glowMC.stop();
                            this.isIdling=false;
                        }
                    }                    
                }
            }
            if(this.leaveTween.isActive){                
                //sparkle
                //check speed
                if(this.lastX!=-99&&this.lastY!=-99&&this.isLeaving){
                    var speed=Math.sqrt(Math.pow(this.tweenContainer.x-this.lastX,2)+Math.pow(this.tweenContainer.y-this.lastY,2));
                    if(speed>5&&Math.round(Math.random())==1){
                        var newSparkle=PIXI.Sprite.fromFrame('sparkle.png');
                        newSparkle.x=this.tweenContainer.x+(Math.random()*100-50);
                        newSparkle.y=this.tweenContainer.y+(Math.random()*100-50);
                        newSparkle.scale.x=0.3;
                        newSparkle.scale.y=0.3;
                        TweenLite.to(newSparkle,1.5,{rotation:2, width:0, height:0, onComplete:this.sparkleRemove,onCompleteParams:[newSparkle],onCompleteScope:this});
                        this.container.addChildAt(newSparkle,0);                        
                    }
                }                
                this.lastX=this.tweenContainer.x;
                this.lastY=this.tweenContainer.y;
            }
            //play button sparkle
            if(this.glowMC.visible){
                var newSparkle=PIXI.Sprite.fromFrame('sparkle.png');
                //find a random point in a circle
                var xPos=Math.random();
                var yPos=Math.random();
                newSparkle.x=this.tweenContainer.x+(yPos*158*Math.cos(2*Math.PI*xPos/yPos));
                newSparkle.y=this.tweenContainer.y+(yPos*104*Math.sin(2*Math.PI*xPos/yPos));
                newSparkle.scale.x=0.3;
                newSparkle.scale.y=0.3;
                newSparkle.rotation=Math.random()*6.283;
                TweenLite.to(newSparkle,1.5,{rotation:newSparkle.rotation+2*(1-Math.round(Math.random()*2)), width:0, height:0, onComplete:this.sparkleRemove,onCompleteParams:[newSparkle],onCompleteScope:this});
                this.container.addChildAt(newSparkle,0);
            }
        }


        public setLeaveTween(tweenToPoints:TweenToData[]):void{
            this.leaveTween = new TimelineMax({delay:0,onReverseComplete:this.leaveReversed,onReverseCompleteScope:this});
            this.leaveTween.pause();
            var tween:TweenMax;
            var twData:TweenToData;
            for (var i = 0, len = tweenToPoints.length; i < len; i++) {
                twData = this.copyTweenData(tweenToPoints[i]);
                twData.vars.onUpdate = this.onTweenUpdate;;
                twData.vars.onUpdateScope = this;
                twData.vars.onStart = this.onTweenStart;
                twData.vars.onStartScope = this;
                tween = TweenMax.to(this.tweenState, twData.duration, twData.vars);
                this.leaveTween.add(tween);
            }
        }        
        
        private leaveReversed(){
            this.leaveMC.visible=false;
            this.restMC.visible=true;
            this.tweenContainer.position.x = 0;
            this.tweenContainer.position.y = 0;
            this.tweenContainer.rotation = 0;
            if (!this.isLeaving){
                var animatedItemReversedEvent:Event = new Event("animatedItemFinishedReset", this);
                this.eventBus.dispatchEvent(animatedItemReversedEvent);
            }
        }

        private copyTweenData(data:TweenToData):TweenToData{
            var  dataCopy:TweenToData = {duration:0, vars:{}};
            dataCopy.duration = data.duration;
            for(var prop in data.vars){
                dataCopy.vars[prop] = data.vars[prop];
            }

            return dataCopy;
        }

        private onTweenStart():void{
            this.tweenState.rotation = this.tweenContainer.rotation;
            this.tweenState.x = this.tweenContainer.x;
            this.tweenState.y = this.tweenContainer.y;
            this.tweenState.scaleX = this.tweenContainer.scale.x;
            this.tweenState.scaleY = this.tweenContainer.scale.y;
        }

        private onTweenUpdate():void{
            this.tweenContainer.rotation = this.tweenState.rotation;
            this.tweenContainer.x = this.tweenState.x;
            this.tweenContainer.y = this.tweenState.y;
            this.tweenContainer.scale.x = this.tweenState.scaleX;
            this.tweenContainer.scale.y = this.tweenState.scaleY;
        }

        private createMovieClip(textureData:ItemAnimationTextureData):MovieClip{
            var textures:Array<PIXI.Texture> = [];
            var frameId:string;
            for(var i:number=1; i<=textureData.nFrames; i++){
                frameId = textureData.framePrefixId + this.padWithZeros(4, i) + '.png';
                textures.push(PIXI.Texture.fromFrame(frameId));
            }
            var mc = new MovieClip(textures);
            mc.animationSpeed = 0.4;
            mc.anchor.x = mc.anchor.y = .5;

            return mc;
        }

        private padWithZeros(width:number, val:number):string{
            var paddedNumber:string = val.toString();
            var padWidth:number = width - paddedNumber.length;

            for(var i:number=0; i<padWidth; i++)
                paddedNumber = '0'+paddedNumber;

            return paddedNumber;
        }
        public sparkleRemove(aSparkle){
            this.container.removeChild(aSparkle);
        }
    }
}
